export default __webpack_public_path__ + "static/media/client-3.70fb8f13.webp";